define('models/pages/basket/basket-item',[
   'models/base/model'
], function(
    Model
) {
    'use strict';

    var BasketItemModel = Model.extend({
        urlPath: '/basket-item',
        destroy: function() {
            this.urlPath = this.urlPath + '/' + this.get('id');
            Model.prototype.destroy.apply(this, arguments);
        }
    });

    return BasketItemModel;
});
